<ion-card [class.ghost]="ghostMode">
    <ion-card-header class="medium-ghost-size ghost-center ghost-height">
        <ion-card-title>{{faqPage?.title}}</ion-card-title>
    </ion-card-header>
    <ion-card-content *ngIf="faqPage?.content">
        <div class="xlarge-ghost-size" [innerHTML]="faqPage?.content | linkify"></div>

        <div class="xlarge-ghost-size contentGhost" *ngIf="ghostMode"></div>
        <div class="medium-ghost-size contentGhost" *ngIf="ghostMode"></div>
    </ion-card-content>
</ion-card>

<ion-card *ngIf="faqPage?.attachedFile || faqPage?.contact?.id"
          class="faq-extras">
    <ion-card-content>
        <faq-file *ngIf="faqPage?.attachedFile" [faqFile]="faqPage?.attachedFile"></faq-file>

        <faq-contact *ngIf="faqPage?.contact?.id" [faqPage]="faqPage"></faq-contact>
    </ion-card-content>
</ion-card>
